import { useDreamComponentsContext } from '@/dreamComponentProvider';

type Props = {
  src?: string;
  children: React.ReactNode;
};

// children should be the base image
export const PictureElement = ({ src, children }: Props) => {
  const { responsiveImagesEnabled, responsiveImagesBreakpoints } = useDreamComponentsContext();

  if (!responsiveImagesEnabled || !responsiveImagesBreakpoints || !src) return children;

  return (
    <picture>
      {responsiveImagesBreakpoints.map((width) => (
        <source
          key={width}
          media={`(max-width: ${width}px)`}
          srcSet={src?.replace('format=auto', `format=auto,width=${width}`)}
        />
      ))}
      {children}
    </picture>
  );
};
